import { render, staticRenderFns } from "./Solution.Open.vue?vue&type=template&id=19591252&"
import script from "./Solution.Open.vue?vue&type=script&lang=js&"
export * from "./Solution.Open.vue?vue&type=script&lang=js&"
import style0 from "./Solution.Open.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

component.options.__file = "Solution.Open.vue"
export default component.exports